import { render, staticRenderFns } from "./balance_details.vue?vue&type=template&id=7bf4bcfe&"
import script from "./balance_details.vue?vue&type=script&lang=js&"
export * from "./balance_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports